import React from 'react';
import dashboardService from '../../services/dashboardService';

const DashboardActivityFeed = ({ activities = [] }) => {
  const getBadgeStyle = status => {
    switch (status?.toLowerCase()) {
      case 'success':
      case 'approved':
        return 'bg-emerald-50 text-emerald-700 border-emerald-200';
      case 'pending':
        return 'bg-amber-50 text-amber-700 border-amber-200';
      case 'cancelled':
      case 'rejected':
        return 'bg-rose-50 text-rose-700 border-rose-200';
      default:
        return 'bg-gray-50 text-gray-700 border-gray-200';
    }
  };

  const getEventIcon = type => {
    switch (type) {
      case 'transaction':
        return (
          <div className='w-7 h-7 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0'>
            <svg className='w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z' />
            </svg>
          </div>
        );
      case 'snap_earn':
        return (
          <div className='w-7 h-7 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center shrink-0'>
            <svg className='w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z' />
            </svg>
          </div>
        );
      case 'topup':
        return (
          <div className='w-7 h-7 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0'>
            <svg className='w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 6v6m0 0v6m0-6h6m-6 0H6' />
            </svg>
          </div>
        );
      default:
        return (
          <div className='w-7 h-7 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center shrink-0'>
            <svg className='w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
            </svg>
          </div>
        );
    }
  };

  return (
    <div className='bg-white rounded-xl border border-gray-200 shadow-xs p-5 transition-all'>
      <div className='flex items-center justify-between mb-4 pb-3 border-b border-gray-100'>
        <h3 className='text-xs font-bold text-gray-500 uppercase tracking-wider'>
          Live Activity Feed
        </h3>
        <span className='inline-flex items-center gap-1.5 text-2xs text-emerald-600 font-semibold'>
          <span className='w-2 h-2 rounded-full bg-emerald-500 animate-pulse'></span>
          Active
        </span>
      </div>

      {activities.length === 0 ? (
        <div className='text-center py-6 text-xs text-gray-400'>
          No recent platform events recorded.
        </div>
      ) : (
        <div className='space-y-4'>
          {activities.map((item, idx) => (
            <div key={item.id || idx} className='flex items-start gap-3'>
              {getEventIcon(item.type)}

              <div className='flex-1 min-w-0'>
                <div className='flex items-center justify-between gap-1'>
                  <p className='text-xs font-bold text-gray-900 truncate'>
                    {item.title}
                  </p>
                  <span className='text-2xs text-gray-400 font-medium shrink-0'>
                    {dashboardService.formatTimeAgo(item.createdAt)}
                  </span>
                </div>

                <p className='text-2xs text-gray-500 truncate mt-0.5'>
                  {item.description}
                </p>

                <div className='flex items-center gap-2 mt-1.5'>
                  {item.amount > 0 && (
                    <span className='text-2xs font-bold text-gray-900'>
                      {dashboardService.formatCurrency(item.amount)}
                    </span>
                  )}
                  <span className={`text-3xs font-bold uppercase tracking-wider px-1.5 py-0.5 rounded border ${getBadgeStyle(item.status)}`}>
                    {item.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardActivityFeed;
